/* DGE Performance — theme.js */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Mobile menu ------------------------------------------------------ */
  var burger = document.querySelector('[data-menu-toggle]');
  var drawer = document.getElementById('hdr-drawer');
  if (burger && drawer) {
    burger.addEventListener('click', function () {
      var open = drawer.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---- Dyno readout count-up -------------------------------------------- */
  var counters = document.querySelectorAll('[data-count]');
  if (counters.length) {
    var run = function (el) {
      var target = parseFloat(el.getAttribute('data-count'));
      if (isNaN(target)) { el.textContent = el.getAttribute('data-count'); return; }
      if (reduced) { el.textContent = target; return; }
      var start = null, dur = 1400;
      var step = function (ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased);
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { run(e.target); io.unobserve(e.target); }
        });
      }, { threshold: 0.4 });
      counters.forEach(function (el) { io.observe(el); });
    } else {
      counters.forEach(run);
    }
  }

  /* ---- Product gallery --------------------------------------------------- */
  var mainImage = document.querySelector('[data-main-image]');
  document.querySelectorAll('[data-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!mainImage) return;
      mainImage.src = btn.getAttribute('data-thumb');
      document.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });

  /* ---- Variant picker ---------------------------------------------------- */
  var root = document.querySelector('[data-product]');
  var json = document.querySelector('[data-variant-json]');
  if (!root || !json) return;

  var variants;
  try { variants = JSON.parse(json.textContent); } catch (e) { return; }
  if (!variants || !variants.length) return;

  var idInput  = root.querySelector('[data-variant-id]');
  var priceEl  = root.querySelector('[data-price]');
  var addBtn   = root.querySelector('[data-add]');
  var addText  = root.querySelector('[data-add-text]');
  var groups   = root.querySelectorAll('.pdp__swatches');

  var selected = [];
  groups.forEach(function (group, i) {
    var active = group.querySelector('.is-active') || group.querySelector('.pdp__swatch');
    selected[i] = active ? active.getAttribute('data-opt-value') : null;
  });

  var match = function () {
    return variants.filter(function (v) {
      return selected.every(function (val, i) { return v.options[i] === val; });
    })[0];
  };

  var apply = function () {
    var v = match();
    if (!v) {
      if (addBtn) addBtn.disabled = true;
      if (addText) addText.textContent = 'Unavailable';
      return;
    }
    if (idInput) idInput.value = v.id;
    if (priceEl) {
      priceEl.innerHTML = (v.on_sale ? '<s>' + v.compare_at + '</s>' : '') + v.price;
    }
    if (addBtn) addBtn.disabled = !v.available;
    if (addText) addText.textContent = v.available ? 'Add to cart' : 'Sold out';
    if (v.image && mainImage) mainImage.src = v.image;

    var url = new URL(window.location.href);
    url.searchParams.set('variant', v.id);
    window.history.replaceState({}, '', url);
  };

  root.querySelectorAll('.pdp__swatch').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var i = parseInt(btn.getAttribute('data-opt-index'), 10);
      selected[i] = btn.getAttribute('data-opt-value');
      btn.parentNode.querySelectorAll('.pdp__swatch').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      apply();
    });
  });
})();

/* Scroll reveal */
(function () {
  var els = document.querySelectorAll('[data-reveal]');
  if (!els.length) return;
  if (!('IntersectionObserver' in window) ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('is-in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  els.forEach(function (el) { io.observe(el); });
})();
(function () {
  var stage = document.querySelector('[data-main-stage]');
  var mediaJsonEl = document.querySelector('[data-media-json]');
  if (!stage || !mediaJsonEl) return;
 
  var mediaList = [];
  try { mediaList = JSON.parse(mediaJsonEl.textContent); } catch (e) { return; }
 
  function findMedia(id) {
    for (var i = 0; i < mediaList.length; i++) {
      if (String(mediaList[i].id) === String(id)) return mediaList[i];
    }
    return null;
  }
 
  function showMedia(m) {
    if (!m) return;
    if (m.type === 'image') {
      stage.innerHTML = '<img data-main-image src="' + m.full + '" alt="' + (m.alt || '') + '">';
    } else if (m.type === 'video') {
      var srcs = (m.sources || []).map(function (s) {
        return '<source src="' + s.url + '" type="' + s.mime + '">';
      }).join('');
      stage.innerHTML = '<video data-main-video controls autoplay playsinline preload="metadata" poster="' + (m.poster || '') + '">' + srcs + '</video>';
    } else if (m.type === 'external_video') {
      stage.innerHTML = '<div class="pdp__embed">' + (m.embed || '') + '</div>';
    } else if (m.full) {
      stage.innerHTML = '<img data-main-image src="' + m.full + '" alt="">';
    }
  }
 
  document.querySelectorAll('.pdp__thumbs [data-media-id]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      showMedia(findMedia(btn.getAttribute('data-media-id')));
      document.querySelectorAll('.pdp__thumbs button').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });
})();
 (function () {
  var btn = document.querySelector('[data-search-toggle]');
  var bar = document.getElementById('hdr-search');
  if (!btn || !bar) return;
  btn.addEventListener('click', function () {
    var open = bar.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) { var input = bar.querySelector('input'); if (input) input.focus(); }
  });
})();

(function () {
  var root = document.querySelector('[data-product]');
  var json = document.querySelector('[data-variant-json]');
  if (!root || !json) return;
 
  var variants;
  try { variants = JSON.parse(json.textContent); } catch (e) { return; }
  if (!variants || !variants.length) return;
 
  var idInput = root.querySelector('[data-variant-id]');
  var priceEl = root.querySelector('[data-price]');
  var addBtn  = root.querySelector('[data-add]');
  var addText = root.querySelector('[data-add-text]');
 
  function norm(s) { return String(s == null ? '' : s).trim().toLowerCase(); }
 
  // Drop any listeners the older script attached, by replacing each button with a clone
  Array.prototype.slice.call(root.querySelectorAll('.pdp__swatches')).forEach(function (group) {
    Array.prototype.slice.call(group.querySelectorAll('.pdp__swatch')).forEach(function (btn) {
      btn.parentNode.replaceChild(btn.cloneNode(true), btn);
    });
  });
 
  var groups = Array.prototype.slice.call(root.querySelectorAll('.pdp__swatches'));
  if (!groups.length) return;
 
  var selected = groups.map(function (group) {
    var active = group.querySelector('.is-active') || group.querySelector('.pdp__swatch');
    return active ? active.getAttribute('data-opt-value') : null;
  });
 
  function exactMatch() {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < selected.length; j++) {
        if (norm(v.options[j]) !== norm(selected[j])) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }
 
  // If the chosen combo doesn't exist, honour the option the user just clicked
  // and snap the other options to the first variant that works.
  function resolve(changedIndex) {
    var v = exactMatch();
    if (v) return v;
    if (changedIndex == null) return variants[0];
 
    var pool = variants.filter(function (x) {
      return norm(x.options[changedIndex]) === norm(selected[changedIndex]);
    });
    if (!pool.length) return null;
 
    v = pool.filter(function (x) { return x.available; })[0] || pool[0];
    selected = v.options.slice();
    syncSwatches();
    return v;
  }
 
  function syncSwatches() {
    groups.forEach(function (group, gi) {
      Array.prototype.slice.call(group.querySelectorAll('.pdp__swatch')).forEach(function (b) {
        if (norm(b.getAttribute('data-opt-value')) === norm(selected[gi])) b.classList.add('is-active');
        else b.classList.remove('is-active');
      });
    });
  }
 
  function apply(changedIndex) {
    var v = resolve(changedIndex);
    if (!v) {
      if (addBtn) addBtn.disabled = true;
      if (addText) addText.textContent = 'Unavailable';
      return;
    }
    if (idInput) idInput.value = v.id;
    if (priceEl) priceEl.innerHTML = (v.on_sale && v.compare_at ? '<s>' + v.compare_at + '</s>' : '') + v.price;
    if (addBtn) addBtn.disabled = !v.available;
    if (addText) addText.textContent = v.available ? 'Add to cart' : 'Sold out';
 
    if (v.image) {
      var mainImg = root.querySelector('[data-main-image]');
      if (mainImg) mainImg.src = v.image;
    }
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    } catch (e) {}
  }
 
  groups.forEach(function (group, gi) {
    Array.prototype.slice.call(group.querySelectorAll('.pdp__swatch')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        selected[gi] = btn.getAttribute('data-opt-value');
        Array.prototype.slice.call(group.querySelectorAll('.pdp__swatch')).forEach(function (b) {
          b.classList.remove('is-active');
        });
        btn.classList.add('is-active');
        apply(gi);
      });
    });
  });
 
  apply(null);
})();
